// Copyright (c) Microsoft Corporation. All rights reserved.
/**
 * Checks if this a [standard gamepad](https://dvcs.w3.org/hg/gamepad/raw-file/default/gamepad.html#remapping)
 */
export function isStandardGamepad(gamepad) {
    return gamepad.axes.length >= 4 && gamepad.buttons.length >= 16;
}
//# sourceMappingURL=isStandardGamepad.js.map